/**
 * InputLabel Component
 *
 * Shared label row used by AppTextInput and AppTextarea.
 * Renders a label with optional required asterisk and character counter.
 */

import { memo } from 'react';

import type { InputLabelProps } from './InputLabel.types';
import styles from './InputLabel.module.css';

export const InputLabel = memo(function InputLabel({
  label,
  required,
  showCounter,
  currentLength,
  maxLength,
}: InputLabelProps) {
  return (
    <div className={styles.labelRow}>
      <span className={styles.labelText}>
        {label}
        {required && <span className={styles.requiredAsterisk}>*</span>}
      </span>
      {showCounter && maxLength !== undefined && (
        <span className={styles.counter}>
          {currentLength}/{maxLength}
        </span>
      )}
    </div>
  );
});

InputLabel.displayName = 'InputLabel';
